module.exports = __webpack_public_path__ + "static/media/bigstock-Call-Center-79077622.bee273b5.jpg";